import Page from '../components/page/Page';
import PageContent from '../components/page/PageContent';
import { Box, Typography, Link, Divider } from '@mui/material';
import ExternalLinks from "../shared/externalLinks";
import { pushEcommercePurchaseEvent } from "../shared/utils";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export default function ConfirmationPage() {
    const { state } = useLocation();
    const isSubscription = state && state.isSubscription;
    const ecommerce = state && state.ecommerce;

    useEffect(() => {
        if (ecommerce) {
            pushEcommercePurchaseEvent(ecommerce);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [seconds, setSeconds] = useState(10);
    useEffect(() => {
        if (seconds === 0) {
            let token: string | null = null;
            if (state) {
                token = state.token;
            }
            if (token) {
               window.location.href = `${ExternalLinks.VCS_PORTAL.LOGIN_FROM_TOKEN}?token=${token}`;
            } else {
                window.location.href = ExternalLinks.VCS_PORTAL.HOME;
            }
            return;
        }
        const intervalId = setInterval(() => {
            setSeconds(seconds - 1);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [seconds]);

    return (
        <Page solidHeader={true}>
            <PageContent color="primary">
                <Box sx={{
                    m: 2,
                    maxWidth: '90vm',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end'
                }}>
                    <Box sx={{
                        m: 2,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Box sx={{ width: '400px' }}>
                            <img style={{ maxWidth: "90vm", width: "100%" }} src={ExternalLinks.AIPEX_SIGNUP_LOGO} />
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 3}}>
                        {isSubscription && <Typography variant="h6">Thank you for subscribing!</Typography>}
                        {!isSubscription && <Typography variant="h6">Thank you for signing up!</Typography>}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 1}}>
                        <Typography align={"center"}>You will be redirected to the Management Portal in {seconds} second(s)</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 1}}>
                        <Typography align={"center"}><strong>Next step:</strong> The next step is to create a property.</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 1}}>
                        <Box sx={{ width: '500px'}}><Divider sx={{ background: "gray", my: 2 }} /></Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 1, fontSize: '1.25rem', textAlign: 'center' }}>
                        <Link href={ExternalLinks.VCS_PORTAL.PROPERTIES}>Click here to go to the Management Portal</Link>
                    </Box>
                </Box>
            </PageContent>
        </Page>
    );
}